import { combineReducers } from 'redux';
import orders from './orders';

export default combineReducers({ orders });
